import { useForm } from 'react-hook-form';
import { ButtonTheme, ModalTheme, RenderForm } from '../../../../components';
import { ContainerButton } from '../../../../styles/global-style';
import { FORM_EDIT_MANAGEMENT_SPECIAL, useFormState } from '../forms';
import { useEffect } from 'preact/hooks';
import { channelBuyQuery } from '../../../../services/react-query/optionMasterQuery';
import { useEditManageData } from '../hooks/useEditManageData';

export const EditModal = ({ open, onToggle, initailValues }) => {
  const { defaultValues } = useFormState(initailValues);
  const { control, setValue, getValues, handleSubmit } = useForm({ defaultValues });
  const { data: channelBuyList } = channelBuyQuery();

  const { mutate: editData } = useEditManageData();

  useEffect(() => {
    if (initailValues) {
      Object.entries(initailValues).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [initailValues, setValue]);

  const onSubmit = (value) => {
    editData(value);
    onToggle({ defaultValues: '' });
  };

  return (
    <ModalTheme title="แก้ไขช่องทางรับประกัน" open={open} onToggle={onToggle}>
      <RenderForm
        control={control}
        forms={FORM_EDIT_MANAGEMENT_SPECIAL({ channelBuyList })}
        setValue={setValue}
        getValues={getValues}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
